import { RootState } from '../../store';

export const getUser = (state: RootState) => state.auth.user;

export const getUserRole = (state: RootState) => state.auth.role;

export const getAPlayerStatus = (state: RootState) => state.auth.aPlayerStatus;


export const isLoading = (state: RootState) => state.auth.loading;
